import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import SpeakingTestEditor from '../../../components/cbt/speaking-test/Editor';
import useAxios from '../../../hooks/useAxios';
import { IGetSpeaking, ISpeakingBody } from '../../../models/newSpeaking.model';
import { postSpeaking } from '../../../api/newSpeaking.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import { useHistory } from 'react-router-dom';
import useNotification from '../../../hooks/useNotification';

const CbtSpeakingTestCreate: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios<IGetSpeaking>();

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.save1'));
      history.push(`/cbt/speaking-test/${submitRes.data.speakingExamCode}/edit`);
    }
  }, [submitRes]);

  const submit = (body: ISpeakingBody) => {
    submitExecute(postSpeaking(body));
  };

  return (
    <div className="content scrollbar">
      {submitIsLoading && <Loader />}
      <ErrorResponse error={submitError} />
      <SimpleHeader
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.speakingTest.1')}
        onlyTitle
      />
      <div>
        <SpeakingTestEditor submit={submit} />
      </div>
    </div>
  );
};

export default CbtSpeakingTestCreate;
